import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <section className="flex min-h-[100svh] items-center bg-navy-950 pt-24" data-testid="not-found-page">
      <div className="container-rcs py-24">
        <p className="font-mono text-sm tracking-[0.3em] text-gold">404</p>
        <h1 className="mt-6 max-w-2xl font-serif text-4xl leading-tight text-ivory sm:text-5xl">
          Looks like this path doesn't lead anywhere yet.
        </h1>
        <p className="mt-6 max-w-xl text-base text-slate-400">
          The page you are looking for may have moved, or may still be under construction.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="btn-gold" data-testid="not-found-home">
            Return Home <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
          <Link to="/brands" className="btn-outline-light" data-testid="not-found-brands">
            Explore Our Brands <ArrowUpRight className="h-4 w-4" aria-hidden />
          </Link>
        </div>
      </div>
    </section>
  );
}
